import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useAuthStore } from '../store';
import toast from 'react-hot-toast';

const C = {
  bg:'#0A0E1A', card:'#0D1526', accent:'#00D4AA',
  text:'#E8EDF5', muted:'#6b7fa3', border:'#1e2d45', red:'#FF4F6A',
};
const fmt = (n) => parseFloat(n||0).toLocaleString('fr-FR');

export default function PaymentLinkPage() {
  const { code } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuthStore();
  const [link, setLink] = useState(null);
  const [amount, setAmount] = useState('');
  const [pin, setPin] = useState('');
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(true);
  const [paying, setPaying] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/marketplace/links/'+code).then(res => {
      setLink(res.data?.link || res.link);
      if (res.data?.link?.amount) setAmount(String(res.data.link.amount));
    }).catch(e => {
      setError(e?.error || 'Lien invalide ou expiré');
    }).finally(() => setLoading(false));
  }, [code]);

  const pay = async () => {
    if (!isAuthenticated) { navigate('/login?redirect=/pay/'+code); return; }
    if (!amount || parseFloat(amount) < 100) return toast.error('Montant minimum 100 FCFA');
    if (pin.length < 6) return toast.error('PIN incomplet');
    setPaying(true);
    try {
      await api.post('/marketplace/links/'+code+'/pay', { amount: parseFloat(amount), pin, note });
      setDone(true);
      toast.success('Paiement effectue !');
    } catch(e) { toast.error(e?.error || 'Erreur paiement'); }
    finally { setPaying(false); }
  };

  if (loading) return (
    <div style={{minHeight:'100vh',background:C.bg,display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{color:C.muted}}>Chargement...</div>
    </div>
  );

  if (error) return (
    <div style={{minHeight:'100vh',background:C.bg,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:24}}>
      <div style={{fontSize:48,marginBottom:16}}>❌</div>
      <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:8}}>Lien invalide</div>
      <div style={{color:C.muted,marginBottom:24}}>{error}</div>
      <button onClick={()=>navigate('/')} style={{background:C.accent,border:'none',borderRadius:12,padding:'12px 24px',color:'#000',fontWeight:700,cursor:'pointer'}}>Accueil PayChat</button>
    </div>
  );

  if (done) return (
    <div style={{minHeight:'100vh',background:C.bg,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:24}}>
      <div style={{fontSize:64,marginBottom:16}}>✅</div>
      <div style={{fontSize:20,fontWeight:700,color:C.accent,marginBottom:8}}>{fmt(amount)} FCFA envoyés</div>
      <div style={{color:C.muted,marginBottom:8}}>à {link?.display_name}</div>
      <div style={{color:C.muted,fontSize:13,marginBottom:24}}>Le paiement a été effectué avec succès</div>
      <button onClick={()=>navigate('/')} style={{background:C.accent,border:'none',borderRadius:12,padding:'12px 24px',color:'#000',fontWeight:700,cursor:'pointer'}}>Retour à PayChat</button>
    </div>
  );

  return (
    <div style={{minHeight:'100vh',background:C.bg,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:20}}>
      {/* Header PayChat */}
      <div style={{marginBottom:24,textAlign:'center'}}>
        <div style={{fontSize:28,fontWeight:800,color:C.accent}}>PayChat</div>
        <div style={{fontSize:13,color:C.muted}}>Paiement sécurisé</div>
      </div>

      <div style={{width:'100%',maxWidth:400,background:C.card,border:'1px solid '+C.border,borderRadius:20,padding:24}}>
        {/* Bénéficiaire */}
        <div style={{textAlign:'center',marginBottom:24}}>
          <div style={{width:64,height:64,borderRadius:32,background:C.accent+'33',display:'flex',alignItems:'center',justifyContent:'center',fontSize:24,fontWeight:700,color:C.accent,margin:'0 auto 12px',overflow:'hidden'}}>
            {link?.avatar_url ? <img src={link.avatar_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/> : (link?.display_name?.[0]||'?').toUpperCase()}
          </div>
          <div style={{fontSize:18,fontWeight:700,color:C.text}}>{link?.display_name}</div>
          <div style={{fontSize:13,color:C.muted}}>@{link?.username}</div>
        </div>

        {/* Titre du lien */}
        <div style={{background:C.bg,borderRadius:12,padding:14,marginBottom:20,textAlign:'center'}}>
          <div style={{fontSize:15,fontWeight:600,color:C.text,marginBottom:4}}>{link?.title}</div>
          {link?.description && <div style={{fontSize:13,color:C.muted}}>{link.description}</div>}
        </div>

        {/* Montant */}
        {link?.amount ? (
          <div style={{textAlign:'center',fontSize:32,fontWeight:800,color:C.accent,marginBottom:20}}>{fmt(link.amount)} FCFA</div>
        ) : (
          <div style={{marginBottom:16}}>
            <div style={{fontSize:13,color:C.muted,marginBottom:6}}>Montant à payer (FCFA)</div>
            <input type="number" style={{width:'100%',background:C.bg,border:'1px solid '+C.border,borderRadius:10,padding:14,color:C.accent,fontSize:24,fontWeight:800,textAlign:'center',outline:'none',boxSizing:'border-box'}}
              placeholder="0" value={amount} onChange={e=>setAmount(e.target.value)} />
          </div>
        )}

        <input style={{width:'100%',background:C.bg,border:'1px solid '+C.border,borderRadius:10,padding:'10px 14px',color:C.text,fontSize:14,outline:'none',boxSizing:'border-box',marginBottom:14}}
          placeholder="Message (optionnel)" value={note} onChange={e=>setNote(e.target.value)} />

        {isAuthenticated ? (
          <>
            <div style={{fontSize:13,color:C.muted,marginBottom:6}}>Code PIN PayChat</div>
            <input type="password" inputMode="numeric" maxLength={6}
              style={{width:'100%',background:C.bg,border:'1px solid '+C.border,borderRadius:10,padding:14,color:C.text,fontSize:24,textAlign:'center',letterSpacing:8,outline:'none',boxSizing:'border-box',marginBottom:20}}
              placeholder="••••••" value={pin} onChange={e=>setPin(e.target.value.replace(/\D/g,''))} />
            <button onClick={pay} disabled={paying} style={{width:'100%',background:C.accent,border:'none',borderRadius:14,padding:16,color:'#000',fontWeight:800,fontSize:16,cursor:'pointer',opacity:paying?0.6:1}}>
              {paying ? 'Traitement...' : 'Payer ' + (amount ? fmt(amount)+' FCFA' : '')}
            </button>
          </>
        ) : (
          <div style={{textAlign:'center'}}>
            <div style={{color:C.muted,fontSize:13,marginBottom:16}}>Connectez-vous à PayChat pour effectuer ce paiement</div>
            <button onClick={()=>navigate('/login?redirect=/pay/'+code)} style={{width:'100%',background:C.accent,border:'none',borderRadius:14,padding:16,color:'#000',fontWeight:800,fontSize:16,cursor:'pointer'}}>
              Se connecter à PayChat
            </button>
            <div style={{marginTop:12,color:C.muted,fontSize:13}}>Pas encore de compte ? <span onClick={()=>navigate('/register')} style={{color:C.accent,cursor:'pointer',fontWeight:600}}>S inscrire</span></div>
          </div>
        )}
      </div>

      <div style={{marginTop:20,color:C.muted,fontSize:12,textAlign:'center'}}>
        Paiement sécurisé par PayChat · ZENVOI SARL · Douala, Cameroun
      </div>
    </div>
  );
}
